module.exports = __webpack_public_path__ + "media/images/favicon-9ac386f01d095923264673b3715c6701.ico";